import { Eleicao } from "./eleicao.model";

export class Email {
    constructor(
        public id?: number,
       public titulo?: string,
       public mensagem?: string,
       public assunto?: string,
       public eleicao?: Eleicao

    ) {}
}